import { useState, useEffect } from "react";
import { Dialog, Box } from "@mui/material";
import Select from "react-select";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Tooltip, IconButton } from "@mui/material";
import {  Trash2, X } from "lucide-react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { REMOVE_FROM_CART } from "../../../../src/redux/domainAddToCart/domainAddToCart.type";
import axios from "axios";
import { ShoppingCart } from 'lucide-react';
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import { Box as BoxIcon, } from "lucide-react";


const CartSubscriptionModal = ({
  subscriptionForm,
  closeSubsciptionModal,
  formErrors,
  formTouched,
  allFieldsValid,
  handleSubscriptionSubmit,
  handleSubscriptionChange,
  showSubscriptionForm,
  loading,
}) => {
  const [subscribableProducts, setSubscribableProducts] = useState([]);
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.domainAddToCart);

  const handleDelete = (id) => {
    dispatch({
      type: REMOVE_FROM_CART,
      payload: id,
    });
  };

  useEffect(() => {
    const fetchSubscribableProducts = async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/products/subscribable`
      );
      if (response.data) {
        setSubscribableProducts(response.data);
      }
    };
    fetchSubscribableProducts();
  }, []);

  return (
    <Dialog
      open={showSubscriptionForm}
      onClose={closeSubsciptionModal}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          height: '90vh',
          maxHeight: "90vh",
          borderRadius: 2,
          width:'85%',
          maxWidth: '80%'
        },
      }}
    >
      <div className="flex flex-col h-full bg-white">
        {/* Header */}
        <div className="bg-[#bb1ccc] px-3 py-4 flex items-center gap-3">
<div className="rounded-lg p-1">
<div className="bg-white rounded-lg p-2 flex items-center justify-center w-13 h-13">
<ShoppingCart sx={{ fontSize: 28, color: "#bb1ccc" }} />
</div>
</div>
<div className="flex-1">
<h2 className="text-white text-[22px] font-semibold">

      Assets Subscription
</h2>
<p className="text-white/90 text-[13px] mt-0.5">

      Manage and subscribe to assets
</p>
</div>
<IconButton

    onClick={closeSubsciptionModal}

    className="text-white hover:bg-white/20 rounded-full p-1 transition-colors"

    size="small"
>
<X size={20} />
</IconButton>
</div>
 

        {/* Main Content */}
        <div className="flex flex-1 overflow-hidden min-h-0">
          {/* Left Side - Form */}
          <div className="w-[58%] px-6 py-3  bg-white overflow-y-auto">
            <Box>
              <form>
                <div className="form-grid">
                  <div className="grid grid-cols-1 gap-2 p-2">
                    <div className="mb-3">
                      <label className="text-[14px] font-bold text-[#5a58ec]">
                        Target Product Name (Project on Azure/GCP){" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <Select
                        name="productName"
                        value={
                          subscriptionForm.productName
                            ? {
                                value: subscriptionForm.productName,
                                label: subscriptionForm.productName,
                              }
                            : null
                        }
                        onChange={(selectedOption) => {
                          handleSubscriptionChange({
                            target: {
                              name: "productName",
                              value: selectedOption ? selectedOption.value : "",
                              readerGroup: selectedOption?.rg_name,
                              source: selectedOption?.source,
                            },
                          });
                        }}
                        options={
                          subscribableProducts?.map((p) => ({
                            ...p,
                            value: p.product_name,
                            label: `${p.product_name} (${
                              p.source === "TERRAFORM"
                                ? "NOT REGISTERED"
                                : p.source
                            })`,
                            searchText: `${p.product_name} ${
                              p.search_text || ""
                            }`.toLowerCase(),
                          })) || []
                        }
                        placeholder="Search a product"
                        isClearable
                        isSearchable
                        filterOption={(option, inputValue) =>
                          option.data.searchText.includes(
                            inputValue.toLowerCase()
                          )
                        }
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            borderColor: state.isFocused ? "#FF03F3" : "#e5e7eb",
                            borderRadius: "0.25rem",
                            padding: "2px",
                            boxShadow: state.isFocused
                              ? "0 0 0 1px #FF03F3"
                              : "none",
                            "&:hover": {
                              borderColor: state.isFocused
                                ? "#FF03F3"
                                : "#cbd5e1",
                            },
                          }),
                          placeholder: (provided) => ({
                            ...provided,
                            color: "#9ca3af",
                          }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isSelected
                              ? "rgba(0, 0, 160, 0.1)"
                              : state.isFocused
                              ? "rgba(0, 0, 160, 0.05)"
                              : "white",
                            color: state.isSelected ? "#FF03F3" : "#374151",
                            "&:active": {
                              backgroundColor: "rgba(0, 0, 160, 0.15)",
                            },
                          }),
                        }}
                        noOptionsMessage={() => "No products found"}
                      />
                      {formTouched && formErrors.productName && (
                        <div className="text-red-500 text-xs">
                          {formErrors.productName}
                        </div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="text-[14px] font-bold text-[#5a58ec]">
                        Reader Group (Auto populates){" "}
                        <span className="text-red-500">*</span>
                        <Tooltip
                          arrow
                          placement="right"
                          title={
                            "Reader groups are auto-populated. If you choose to edit them, please ensure the values are correct; otherwise, access will not be granted."
                          }
                          componentsProps={{
                            tooltip: {
                              sx: {
                                fontSize: "0.95rem",
                                lineHeight: 1.5,
                                maxWidth: 320,
                              },
                            },
                          }}
                        >
                          <IconButton size="small">
                            <InfoOutlinedIcon fontSize="medium" />
                          </IconButton>
                        </Tooltip>
                      </label>
                      <input
                        name="readerGroup"
                        value={subscriptionForm.readerGroup}
                        onChange={handleSubscriptionChange}
                        placeholder="Enter Reader Group"
                        className="w-full border rounded p-2 focus:outline focus:outline-2 focus:outline-[#FF03F3]  h-[42px]"
                      />
                      {subscriptionForm.readerGroup && (
                        <div className="flex flex-wrap gap-2 mt-2">
                          {subscriptionForm.readerGroup
                            .split("|")
                            .map((group, index) => (
                              <span
                                key={index}
                                className="bg-[#afaae9] text-white text-xs px-3 py-1 rounded-full"
                              >
                                {group}
                              </span>
                            ))}
                        </div>
                      )}
                      {formTouched && formErrors.readerGroup && (
                        <div className="text-red-500 text-xs">
                          {formErrors.readerGroup}
                        </div>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="text-[14px] font-bold text-[#5a58ec]">
                        Usage Duration <span className="text-red-500">*</span>
                      </label>
                      <select
                        name="usageDuration"
                        value={subscriptionForm.usageDuration}
                        onChange={handleSubscriptionChange}
                        className="w-full border rounded p-2 focus:outline focus:outline-2 focus:outline-[#FF03F3]  h-[42px]"
                      >
                        <option value="">Select Usage Duration</option>
                        <option value="3months">3 Months</option>
                        <option value="6months">6 Months</option>
                        <option value="1year">1 Year</option>
                        <option value="lifetime">Lifetime</option>
                      </select>
                      {formTouched && formErrors.usageDuration && (
                        <div className="text-red-500 text-xs">
                          {formErrors.usageDuration}
                        </div>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="text-[14px] font-bold text-[#5a58ec]">
                        Usage Description <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="usageDescription"
                        value={subscriptionForm.usageDescription}
                        onChange={handleSubscriptionChange}
                        placeholder="Describe how you plan to use this data"
                        className="w-full border rounded p-2 focus:outline focus:outline-2 focus:outline-[#FF03F3]  h-[42px] "
                      />
                      {formTouched && formErrors.usageDescription && (
                        <div className="text-red-500 text-xs">
                          {formErrors.usageDescription}
                        </div>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="text-[14px] font-bold text-[#5a58ec]">
                        Subscribe Email <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="email"
                        name="notificationEmail"
                        value={subscriptionForm.notificationEmail}
                        onChange={handleSubscriptionChange}
                        placeholder="Enter email (@effem.com)"
                        className="w-full border rounded p-2 
               focus:outline focus:outline-2 focus:outline-[#FF03F3]
               outline-offset-0 h-[42px]"
                      />

                      {formTouched && formErrors.notificationEmail && (
                        <div className="text-red-500 text-xs">
                          {formErrors.notificationEmail}
                        </div>
                      )}
                      {!formTouched &&
                        subscriptionForm.notificationEmail &&
                        formErrors.notificationEmail && (
                          <div className="text-red-500 text-xs mt-1">
                            {formErrors.notificationEmail}
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="form-consent">
                    <input
                      type="checkbox"
                      name="acceptTerms"
                      checked={subscriptionForm.acceptTerms}
                      onChange={handleSubscriptionChange}
                    />
                    <label>
                      I agree to the data contract terms and will use the data in
                      accordance with the specified quality requirements and usage
                      guidelines.
                    </label>
                  </div>
                  <div className="flex justify-end gap-2 mt-4">
                    <button
                      type="button"
                      onClick={closeSubsciptionModal}
                      className="px-4 py-2 bg-gray-200 rounded"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={handleSubscriptionSubmit}
                      className={`px-4 py-2 rounded ${
                        !subscriptionForm.acceptTerms || !allFieldsValid
                          ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                          : "bg-[#FF03F3] text-white"
                      } `}
                      disabled={
                        !subscriptionForm.acceptTerms ||
                        !allFieldsValid ||
                        loading
                      }
                    >
                      {loading ? "Submitting.." : "Subcribe"}
                    </button>
                  </div>
                </div>
              </form>
            </Box>
          </div>

          {/* Right Side - Product Basket */}
          <div className="w-[42%] bg-white flex flex-col border-l border-gray-200">
            {/* Basket Header */}
            

               <div className="px-[20px] py-2 flex items-center justify-between border-b border-gray-200">
            
                           <p className="text-[#5a58ec] font-bold text-[15px]  ">
                            <ShoppingBagOutlinedIcon className="text-[#5a58ec] ml-[4px] "/> Product Basket  ( {(cartItems && cartItems?.length) || 0} )</p>

            </div>

            {/* Cart Items */}
            <div className="flex-1 overflow-y-auto px-5 py-4">
              <div className="space-y-3">
                {cartItems?.map((item, index) => (
                  <div
                    key={index}
                    className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-sm transition-shadow"
                  >
                    <div className="flex items-center gap-3 p-3">
                      <div className="shrink-0">
                        <div className=" p-2">
                          <BoxIcon  size={20} className="text-[#5a58ec] semibold" />
                        </div>
                      </div>
                    
                      <div className="flex-1 min-w-0">

  {/* Asset Name with Tooltip */}
<div className="text-[13px] font-medium text-gray-900 truncate">

    {item?.name && item.name.length > 20 ? (
<Tooltip

        title={item.name}

        componentsProps={{

          tooltip: {

            sx: {

              backgroundColor: "#ece5e5ff",

              color: "black",

              fontSize: "10px",

              fontFamily: "Poppins",

              padding: "8px 10px",

              borderRadius: "6px",

              maxWidth: "400px",

              whiteSpace: "pre-wrap",

            },

          },

        }}
> 
<span className="cursor-pointer">

          {item.name.substring(0, 20)}...
</span>
</Tooltip>

    ) : (
<span>{item?.name || "Asset Name"}</span>

    )}
</div>
 
  {/* Product Name with Tooltip */}
<div className="text-[11px] text-gray-500 mt-0.5">

    Product Name : {" "}

    {item?.productName && item.productName.length > 20 ? (
<Tooltip

        title={item.productName}

        componentsProps={{

          tooltip: {

            sx: {

              backgroundColor: "#ece5e5ff",

              color: "black",

              fontSize: "10px",

              fontFamily: "Poppins",

              padding: "8px 10px",

              borderRadius: "6px",

              maxWidth: "400px",

              whiteSpace: "pre-wrap",

            },

          },

        }}
>
<strong className="cursor-pointer">

          {item.productName.substring(0, 20)}...
</strong>
</Tooltip>

    ) : (
<strong>{item?.productName || "Product Name is unavailable currently"}</strong>

    )}
</div>
</div>
 
                      <div className="shrink-0">
                        <button
                          onClick={() => handleDelete(item?.id)}
                          className="p-1 hover:bg-gray-100 rounded transition-colors"
                        >
                          <Trash2 size={14} className="text-red-600" />
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Cart Footer */}
            <div className="px-5 py-4 bg-white border-t border-gray-200">
              <div className="flex items-center justify-between mb-3">
                <span className="text-[13px] font-semibold text-gray-700">
                  Total Items:
                </span>
                <span className="text-xl font-bold text-gray-900">
                  {(cartItems && cartItems?.length) || 0}
                </span>
              </div>
              <button
                onClick={() => {
                  cartItems?.forEach((item) => handleDelete(item?.id));
                }}
                className="w-full px-4 py-2 text-[13px] text-red-600 hover:text-red-700 font-medium rounded-md hover:bg-red-50 transition-colors"
              >
                Clear Cart
              </button>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default CartSubscriptionModal;
 